<cb-dialog>
    @if (data.contactType === BUSINESS_ACCOUNT_CONTACT_TYPE_ENUM.Orders) {
        <mat-radio-group class="cb-margin-bottom-2x" [(ngModel)]="hasOptionalEmailAddress">
            <div class="flex-col">
                <mat-radio-button [value]="false">Email</mat-radio-button>
                <span class="cb-margin-top-2x">{{ data.contact.email }}</span>
            </div>
            <form class="cb-margin-top-2x flex-col">
                <mat-radio-button [value]="true">Optional Email Address</mat-radio-button>
                <cb-input
                    label="Optional Email Address"
                    name="emailAddress"
                    [disabled]="!hasOptionalEmailAddress"
                    [maxlength]="150"
                    [(ngModel)]="emailAddress"
                ></cb-input>
            </form>
        </mat-radio-group>
    }
    <cb-business-account-location-picker
        [isForm]="true"
        [region]="region"
        [district]="district"
        [area]="area"
        [availableLocations]="availableLocations"
        (locationChange)="onLocationChanged($event)"
    >
    </cb-business-account-location-picker>
    @if (data.contactType === BUSINESS_ACCOUNT_CONTACT_TYPE_ENUM.Installation) {
        <form class="cb-margin-top-2x">
            @switch (!data.contactLocation) {
                @case (true) {
                    <div>
                        <span class="cb-label">Trade Types</span>
                        @for (type of availableTradeTypes; track type) {
                            <cb-checkbox
                                [name]="'tradeType' + type.id"
                                [label]="type.label"
                                [ngModel]="isTradeTypeChecked(type.id)"
                                (change)="onTradeTypeChanged(type.id, $event)"
                            ></cb-checkbox>
                        }
                    </div>
                }
                @default {
                    <div>
                        <cb-select
                            label="Trade Type"
                            name="tradeType"
                            [required]="true"
                            [options]="availableTradeTypes"
                            [ngModel]="selectedTradeTypes[0]"
                            (change)="selectedTradeTypes[0] = $event"
                        ></cb-select>
                    </div>
                }
            }
        </form>
    }
    <div actions>
        <span class="flex"></span>
        <button mat-raised-button color="primary" [disabled]="!canSave()" (click)="onSaveClicked()">
            Save
        </button>
        <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
    </div>
</cb-dialog>
